let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("98LiC")).then(() => parcelRequire('1dTgQ'));